import React from "react";
import { banState, ExamInfoByStuItem } from "service/exam";
import style from "./index.module.scss";

interface StudentInfoProps {
    data?: ExamInfoByStuItem; //学生基本信息
    ban: string; //禁考标志
}

export default function StudentInfo({ data, ban }: StudentInfoProps) {
    return (
        <div>
            <div className={style.title}>考生基本信息</div>
            <div className={style.avater}>
                <img src={require("../img/avater.png")} />
            </div>
            <div className={style.item}>
                <span className={style.label}>姓名：</span>
                {data?.stuName ? data.stuName : "--"}
            </div>
            {ban === banState.confirm && (
                <div className={style.error}>
                    该考生存在缺考、弃考或作弊行为，被老师“禁考”。
                </div>
            )}
            <div className={style.item}>
                <span className={style.label}>学号：</span>
                {data?.stuNo ? data.stuNo : "--"}
            </div>
            <div className={style.item}>
                <span className={style.label}>性别：</span>
                {data?.sex ? data.sex : "--"}
            </div>
            <div className={style.item}>
                <span className={style.label}>班级：</span>
                {data?.className ? data.className : "--"}
            </div>
            <div className={style.item}>
                <span className={style.label}>专业：</span>
                {data?.subject ? data.subject : "--"}
            </div>
            <div className={style.item}>
                <span className={style.label}>学院：</span>
                {data?.department ? data.department : "--"}
            </div>
        </div>
    );
}
